import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginRegister.css';
import { FaUserAlt, FaLock, FaEnvelope } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";

const baseURL = process.env.BASE_URL || "";

const LoginRegister = () => {
  const [action, setAction] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  // Redirect if already logged in
  useEffect(() => {
    const token = localStorage.getItem('userId');
    if (token) navigate('/images');
  }, [navigate]);

  const registerLink = () => {
    setAction('active');
    setMessage('');
  };

  const loginLink = () => {
    setAction('');
    setMessage('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // USER SIGNUP
  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/auth/signup/user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: formData.username.trim(),
          email: formData.email.trim(),
          password: formData.password,
          confirmPassword: formData.confirmPassword,
        }),
      });

      const data = await response.json();
      console.log(data);
      

      if (!response.ok) {
        throw new Error(data.msg || 'Registration failed');
      }

      setMessage('Registration successful! Please login.');
      setAction(''); // Switch to login form
      setFormData({
        username: '',
        email: '',
        password: '',
        confirmPassword: ''
      });
    } catch (err) {
      setMessage(err.message || 'Registration failed');
    } finally {
      setIsLoading(false);
    }
  };

  // USER SIGNIN
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${baseURL}/api/auth/signin/user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: formData.username.trim(),
          password: formData.password,
        }),
      });
      console.log(response);
      
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || 'Login failed');
      }

      // Save token and user ID
      //localStorage.setItem('token', data.token);
      localStorage.setItem('userId', data.userId);

      // Redirect to protected route
      navigate('/images');
    } catch (err) {
      setMessage(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='box'>
      <div className={`wrapper ${action}`}>
        {/* Sign In Form */}
        <div className='form-box login'>
          <form onSubmit={handleLogin}>
            <h1>SIGN IN</h1>
            <div className='input-box'>
              <input
                type='text'
                name='username'
                placeholder='Username'
                value={formData.username}
                onChange={handleInputChange}
                required
              />
              <FaUserAlt className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='password'
                name='password'
                placeholder='Password'
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <FaLock className='icon' />
            </div>

            <div className='remember-forgot'>
              <label>
                <input type='checkbox' /> Remember me
              </label>
              <a href='#'>Forgot Password?</a>
            </div>

            <button type='submit' disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Sign In'}
            </button>

            {message && (
              <p className={`message ${message.includes('success') ? 'success' : 'error'}`}>
                {message}
              </p>
            )}

            <div className='register-link'>
              <p>Don't have an account? <a href='#' onClick={registerLink}>Sign Up</a></p>
            </div>
          </form>
        </div>

        {/* Sign Up Form */}
        <div className='form-box register'>
          <form onSubmit={handleRegister}>
            <h1>SIGN UP</h1>
            <div className='input-box'>
              <input
                type='text'
                name='username'
                placeholder='Username'
                value={formData.username}
                onChange={handleInputChange}
                required
              />
              <FaUserAlt className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='email'
                name='email'
                placeholder='Email'
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <FaEnvelope className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='password'
                name='password'
                placeholder='Password'
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <FaLock className='icon' />
            </div>

            <div className='input-box'>
              <input
                type='password'
                name='confirmPassword'
                placeholder='Confirm Password'
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required
              />
              <SiTicktick className='icon' />
            </div>

            <div className='remember-forgot'>
              <label>
                <input type='checkbox' required /> I agree to the terms & conditions
              </label>
            </div>

            <button type='submit' disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Sign Up'}
            </button>

            {message && (
              <p className={`message ${message.includes('success') ? 'success' : 'error'}`}>
                {message}
              </p>
            )}

            <div className='register-link'>
              <p>Already have an account? <a href='#' onClick={loginLink}>Sign In</a></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginRegister;